import { useSiteStore } from '@/store/site';
import { smpService } from '@/services/smp.service';
import { useAccount } from '@/hooks/query/account';

type HasSingleMatchParlayParams = {
	sport: number;
	id34: string;
	isLive: boolean;
	isIR: boolean;
	betBuilderStatus: number;
	showTime: string;
};

export const useHasSingleMatchParlay = ({
	sport, 
	id34, 
	isLive, 
	isIR, 
	betBuilderStatus,
	showTime
}: HasSingleMatchParlayParams) => {
	const isParlayMode = useSiteStore(state => state.isParlayMode);
	const { data: accountData } = useAccount(data => {
		const accountInfo = data.data.Data;

		return {
			smp1: accountInfo?.SMP_1,
			smp2: accountInfo?.SMP_2,
			smpLive1: accountInfo?.SMPLive_1,
			smpLive2: accountInfo?.SMPLive_2,
		};
	});

	return smpService.checkSmpAvailability({
		sport,
		id34,
		isLive,
		isIR,
		betBuilderStatus,
		showTime,
		isParlayMode,
	}, accountData);
};